import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import './SingleDateSelector.css';
import { getFormattedDate, getMomentDate } from '../../../utils/momentUtils.js';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
export const SingleDateSelector = ({ id, value, onChange, locale, singleDatePickerProps = {
    showClearDate: true,
    showDefaultInputIcon: true,
}, myErrors, isMobile, numberOfMonths, vertical, useTailwindPrefix, version, }) => {
    const [focused, setFocused] = useState(false);
    const [date, setDate] = useState(getMomentDate(value, locale));
    const intl = useIntl();
    useEffect(() => {
        setDate(getMomentDate(value, locale));
    }, [value, locale]);
    const onFocusChange = ({ focused }) => {
        setFocused(focused || false);
        if (document && document.body) {
            if (!focused) {
                if (!useTailwindPrefix) {
                    document.body.className = document.body.className.replace(/ ?fixed md:relative/, '');
                }
                else {
                    document.body.className = document.body.className.replace(/ ?tw-fixed md:tw-relative/, '');
                }
            }
            else {
                let orig = document.body.className;
                if (!useTailwindPrefix) {
                    if (orig.indexOf('fixed md:relative') < 0) {
                        document.body.className = orig + (orig ? ' ' : '') + 'fixed md:relative';
                    }
                }
                else {
                    if (orig.indexOf('tw-fixed md:tw-relative') < 0) {
                        document.body.className = orig + (orig ? ' ' : '') + 'tw-fixed md:tw-relative';
                    }
                }
            }
        }
    };
    const onDateChange = (date) => {
        setDate(date);
        onChange(getFormattedDate(date, locale, 'YYYY-MM-DD'));
    };
    moment.locale(locale);
    return (_jsxs("div", Object.assign({ className: classNames({
            'whitespace-nowrap': !useTailwindPrefix,
            'tw-whitespace-nowrap': useTailwindPrefix,
            'border-b-red-400 mb-5': myErrors && !useTailwindPrefix,
            'tw-border-b-red-400 tw-mb-5': myErrors && useTailwindPrefix,
            'md:mb-0': myErrors && !vertical && !useTailwindPrefix,
            'md:tw-mb-0': myErrors && !vertical && useTailwindPrefix,
        }) }, { children: [_jsx("div", Object.assign({ className: classNames('itm-sds', { 'itm-sds-h': !vertical, 'itm-sds--error': myErrors }) }, { children: locale && (_jsx(SingleDatePicker, Object.assign({ firstDayOfWeek: 1, transitionDuration: 0, date: date, id: id, onDateChange: onDateChange, focused: focused, onFocusChange: onFocusChange, readOnly: true, hideKeyboardShortcutsPanel: true, numberOfMonths: numberOfMonths }, (isMobile && {
                    orientation: 'vertical',
                    withFullScreenPortal: true,
                }), singleDatePickerProps))) })), myErrors && (_jsx("div", Object.assign({ className: classNames({
                    'md:mt-2 md:pt-widget-pill-padding-y': version === 'padded' && !useTailwindPrefix,
                    'md:tw-mt-2 md:tw-pt-widget-pill-padding-y': version === 'padded' && useTailwindPrefix,
                    'text-red-400 mt-1 text-sm truncate w-full absolute': !useTailwindPrefix,
                    'tw-text-red-400 tw-mt-1 tw-text-sm tw-truncate tw-w-full tw-absolute': useTailwindPrefix,
                }) }, { children: myErrors.message || intl.formatMessage({ id: 'booker.errors.correctFields' }) })))] })));
};
